export default __webpack_public_path__ + "static/media/yo_8.81d9e068.mp3";